
import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";

import rootSaga from "sagas";
import rootReducer from "reducers";
import {
    loggerMiddleware,
    caseServiceMiddleware,
    stageNameEnhancerMiddleware,
    proceedChecklistInitializerMiddleware
} from "middlewares";

const sagaMiddleware = createSagaMiddleware();

/*eslint-disable no-undef*/
const enhancers =
    process.env.NODE_ENV === "production"
        ? composeWithDevTools({})(
            applyMiddleware(
                proceedChecklistInitializerMiddleware,
                stageNameEnhancerMiddleware,
                caseServiceMiddleware,
                sagaMiddleware
            )
        )
        : composeWithDevTools({})(
            applyMiddleware(
                proceedChecklistInitializerMiddleware,
                stageNameEnhancerMiddleware,
                caseServiceMiddleware,
                sagaMiddleware,
                loggerMiddleware
            )
        );
/*eslint-disable no-undef*/
export default createStore(
    rootReducer,
    {},
    enhancers
);
/*eslint-disable no-undef*/
sagaMiddleware.run(rootSaga);
